var QUERY_START = /^[?#]/;
var ARRAY_END = /\[\]$/; // Shorthand to make it smaller
var dec = decodeURIComponent;
/**
 * Parses a query-string, including the leading ?.
 */

var parseParams = query => {
  query = QUERY_START.test(query) ? query.slice(1) : query;

  if (!query) {
    return {};
  }

  return query.split("&").reduce((params, param) => {
    var _param$split = param.split("="),
        key = _param$split[0],
        value = _param$split[1];

    var val = typeof value === "undefined" ? null : dec(String(value).replace(/\+/g, " "));
    var isArray = ARRAY_END.test(key);
    var k = dec(isArray ? key.replace(ARRAY_END, "") : key);

    if (k) {
      if (isArray && params[k]) {
        params[k] = Array.isArray(params[k]) ? params[k].concat([val]) : [params[k], val];
      } else {
        params[k] = val;
      }
    }

    return params;
  }, {});
};

export { parseParams };
//# sourceMappingURL=location-search-string.js.map
